/* =====================================================================
   PLAKTON · pk-quick-add.js
   Compra rápida desde las fichas: añadir talla con un clic (escritorio)
   y panel de tallas (móvil / táctil). Usa la cesta lateral del tema Ella
   cuando está disponible.
   ===================================================================== */
(function () {
  'use strict';
  if (window.PKQuickAdd) return;

  var strings = window.pkQuickAddStrings || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  function t(key, fallback) { return strings[key] || fallback; }
  function attr(str) { return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function html(str) { return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }

  /* ---------- Cesta ---------- */
  function addToCart(variantId) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) throw new Error(data.description || data.message || t('error', 'Error'));
        return data;
      });
    });
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCount(cart) {
    var count = cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count >= 100 && window.cartStrings && window.cartStrings.item_99 && el.closest('.cart-count-bubble') ? window.cartStrings.item_99 : count;
    });
    if (window.cartStrings) {
      document.querySelectorAll('[data-cart-text]').forEach(function (el) {
        el.textContent = count === 1 ? window.cartStrings.item : window.cartStrings.items;
      });
    }
  }

  function afterAdd() {
    var mode = (window.after_add_to_cart && window.after_add_to_cart.type) || 'quick_cart';
    if (mode === 'cart') {
      window.location.href = (window.routes && window.routes.cart) || root + 'cart';
      return Promise.resolve(true);
    }
    return getCart().then(function (cart) {
      updateCount(cart);
      var canOpenSidebar = window.quick_cart && window.quick_cart.show && window.sharedFunctions &&
        typeof window.sharedFunctions.updateSidebarCart === 'function' && document.getElementById('halo-cart-sidebar');
      if (canOpenSidebar) {
        window.sharedFunctions.updateSidebarCart(cart);
        document.body.classList.add('cart-sidebar-show');
        return true;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      return false;
    });
  }

  function setStatus(el, msg, isError) {
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('is-error', !!isError);
  }

  function handleAdd(btn, statusEl, onDone) {
    if (!btn || btn.disabled || btn.classList.contains('is-loading')) return;
    var id = btn.getAttribute('data-id');
    var panel = btn.closest('.pk-qa__panel');
    var qa = btn.closest('[data-pk-qa]') || (panel && panel._qa);
    var item = (panel || btn).closest('.product-item');
    if (item) item.classList.add('is-busy');
    btn.classList.add('is-loading');
    setStatus(statusEl, t('adding', 'Adding…'));
    addToCart(id)
      .then(function () { return afterAdd(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setStatus(statusEl, t('added', 'Added to your cart'));
        setTimeout(function () {
          btn.classList.remove('is-added');
          setStatus(statusEl, '');
          if (item) item.classList.remove('is-busy');
        }, 2200);
        if (typeof onDone === 'function') onDone();
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        if (item) item.classList.remove('is-busy');
        setStatus(statusEl, err.message || t('error', 'Error'), true);
      });
  }

  /* ---------- Barra "Añadir + tallas" sobre la foto (escritorio): el panel se queda dentro de la imagen ---------- */
  function prepare(scope) {
    (scope || document).querySelectorAll('[data-pk-qa]').forEach(function (qa) {
      if (qa.dataset.pkReady) return;
      var item = qa.closest('.product-item');
      var panel = qa.querySelector('.pk-qa__panel');
      if (!item || !panel) return;
      qa.dataset.pkReady = '1';
      qa._panel = panel;
      panel._qa = qa;
      item.classList.add('pk-has-qa');
    });
  }

  /* ---------- Ficha: pasar fotos con flechas al pasar el ratón ---------- */
  function cgalBase(media) {
    return media.classList.contains('media--hover-effect') && media.querySelectorAll(':scope > img').length > 1 && window.matchMedia('(hover: hover) and (pointer: fine)').matches ? 1 : 0;
  }
  function cgalStep(btn, dir) {
    var g = btn.closest('[data-pk-cgal]');
    var media = g && g.closest('.card-media');
    if (!media) return;
    var list;
    try { list = JSON.parse(g.getAttribute('data-imgs')); } catch (e) { return; }
    if (!list || list.length < 2) return;
    /* Con el cambio de foto del hover ya se ve la 2.ª foto: se parte de ella, así el primer clic avanza a la 3.ª */
    var base = cgalBase(media);
    var cur = g.dataset.i != null && g.dataset.i !== '' ? parseInt(g.dataset.i, 10) : base;
    var i = ((cur + dir) % list.length + list.length) % list.length;
    g.dataset.i = i;
    var layer = media.querySelector('.pk-cgal__img');
    if (i === base) { if (layer) layer.classList.remove('is-on'); media.classList.remove('pk-cgal-active'); return; }
    if (!layer) {
      var wrap = document.createElement('span');
      wrap.className = 'pk-cgal__layer';
      layer = document.createElement('img');
      layer.className = 'pk-cgal__img';
      layer.alt = '';
      layer.decoding = 'async';
      wrap.appendChild(layer);
      media.insertBefore(wrap, media.querySelector('.card-link') || g);
    }
    /* La foto actual se mantiene hasta que la nueva está lista (sin parpadeos) */
    layer.onload = function () { layer.classList.add('is-on'); };
    layer.src = list[i];
    if (layer.complete && layer.naturalWidth) layer.classList.add('is-on');
    media.classList.add('pk-cgal-active');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pk-cgal-prev], [data-pk-cgal-next]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    cgalStep(b, b.hasAttribute('data-pk-cgal-next') ? 1 : -1);
    if (b.blur) b.blur();
  }, true);
  /* Precarga: al poner el ratón sobre la ficha se descargan sus fotos, así las flechas responden al instante */
  var cgalPre = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  document.addEventListener('mouseover', function (e) {
    var item = e.target.closest && e.target.closest('.product-item');
    if (!item || !cgalPre || cgalPre.has(item)) return;
    cgalPre.add(item);
    var g = item.querySelector('[data-pk-cgal]');
    if (!g) return;
    var list; try { list = JSON.parse(g.getAttribute('data-imgs')); } catch (err) { return; }
    /* Primero las que se verán con el primer clic (siguiente y anterior), luego el resto */
    var order = [2, 0].concat((list || []).map(function (_, k) { return k; }).filter(function (k) { return k > 2; }));
    order.forEach(function (k, n) {
      if (!list[k]) return;
      setTimeout(function () { var im = new Image(); im.decoding = 'async'; im.src = list[k]; }, n * 40);
    });
  }, { passive: true });
  /* Al salir de la ficha, todo vuelve a su estado normal (primera foto, sin capas) */
  function cgalReset(item) {
    var g = item.querySelector('[data-pk-cgal]');
    if (g) g.dataset.i = '';
    var img = item.querySelector('.pk-cgal__img');
    if (img) img.classList.remove('is-on');
    var media = item.querySelector('.card-media');
    if (media) media.classList.remove('pk-cgal-active');
    if (document.activeElement && item.contains(document.activeElement) && document.activeElement.blur) document.activeElement.blur();
  }
  document.addEventListener('mouseout', function (e) {
    var item = e.target.closest && e.target.closest('.product-item');
    if (!item || (e.relatedTarget && item.contains(e.relatedTarget))) return;
    cgalReset(item);
  });


  /* ---------- Ficha: puntos de color (otros colores del mismo modelo y acabado) ---------- */
  var SW_FINS = 'wool comfort,afelpado,nobuck,classic,houston,dakota,chicago,bio,apure,evalight,leather,glitter,boreal,charol'.split(',');
  var SW_COLORS = {
    'black': '#1d1d1d', 'negro': '#1d1d1d', 'white': '#f4f2ee', 'blanco': '#f4f2ee', 'ice': '#e9ecee', 'stone': '#cdbfae', 'sand': '#d9c7a7',
    'beige': '#d8c4a4', 'beig': '#d8c4a4', 'cream': '#efe6d2', 'arena': '#d6c09b', 'taupe': '#8f7d6d', 'vison': '#8c7b6b', 'tan': '#b8875a',
    'camel': '#b58552', 'cognac': '#9a5a2c', 'brown': '#5b3a26', 'light brown': '#8a5d3b', 'light-brown': '#8a5d3b', 'choco': '#4a2f22',
    'chocolate': '#4a2f22', 'moka': '#5c4033', 'oak': '#a0703f', 'oak-light': '#b98a55', 'roble': '#9a6a3c', 'castagna': '#6e4428', 'khaki': '#6f6a3e',
    'light khaki': '#8f8a5a', 'light-khaki': '#8f8a5a', 'vintage-khaki': '#7c7550', 'olive': '#5f5f34', 'green': '#4f6b3a', 'mint': '#a9cdb3',
    'menta': '#a9cdb3', 'pistachio': '#b9cc8f', 'aqua': '#7fc6c4', 'blue': '#3a5f8f', 'navy': '#22304a', 'jeans': '#4b6584', 'sinai': '#c9a77c',
    'grey': '#8d8f91', 'gray': '#8d8f91', 'anthracite': '#3c4144', 'antracit': '#3c4144', 'iron': '#4a4d50', 'silver': '#c9cbcd', 'gold': '#c9a54a',
    'pink': '#e6a8b8', 'rosa': '#e6a8b8', 'fuxia': '#c2367a', 'lilac': '#b8a3cf', 'peach': '#f2b89a', 'salmon': '#ee9f86', 'mango': '#f2a541',
    'orange': '#e5783b', 'yellow': '#ecc94b', 'red': '#b93b32', 'wine': '#6e1f2a', 'bordeaux': '#6a1f2b', 'cherry': '#7b1e2b', 'multi': 'conic-gradient(#e5783b,#ecc94b,#4f6b3a,#3a5f8f,#c2367a,#e5783b)',
    'burdeos': '#6a1f2b', 'antique': '#8b6b4a', 'military': '#4b5320', 'fango': '#6b5b4b', 'muskat': '#9c7a5b', 'ocre': '#c08a2e', 'cuero': '#8b5a2b', 'mushroom': '#a59482', 'bleir': '#7d8fa3', 'tostado': '#8a5a35', 'coffee': '#4b3226', 'lino': '#d9cdb8',
    'print': 'linear-gradient(135deg,#1d1d1d 50%,#f4f2ee 50%)', 'zebra': 'linear-gradient(135deg,#1d1d1d 50%,#f4f2ee 50%)'
  };
  function swFin(t) { t = t.toLowerCase(); for (var i = 0; i < SW_FINS.length; i++) if (t.indexOf(SW_FINS[i]) > -1) return SW_FINS[i]; return ''; }
  function swColor(title, model, fin) {
    var c = title.toLowerCase().replace(model.toLowerCase(), '').replace(fin, '').replace(/®/g, '').replace(/\s+/g, ' ').trim();
    if (SW_COLORS[c]) return SW_COLORS[c];
    var words = c.split(/[\s]+/);
    for (var i = words.length - 1; i >= 0; i--) {
      if (i > 0 && SW_COLORS[words[i - 1] + ' ' + words[i]]) return SW_COLORS[words[i - 1] + ' ' + words[i]];
      if (SW_COLORS[words[i]]) return SW_COLORS[words[i]];
      var parts = words[i].split('-');
      for (var j = parts.length - 1; j >= 0; j--) if (SW_COLORS[parts[j]]) return SW_COLORS[parts[j]];
    }
    return '';
  }
  var swCache = {};
  function swFetch(base, model) {
    if (swCache[model]) return swCache[model];
    var url = base + '?view=pk_model&type=product&options%5Bfields%5D=title&options%5Bprefix%5D=last&q=' + encodeURIComponent(model);
    swCache[model] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) { return d.items || []; }).catch(function () { return []; });
    return swCache[model];
  }
  function swInit(scope) {
    (scope || document).querySelectorAll('[data-pk-sw]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '1');
      var model = el.getAttribute('data-model'), fin = el.getAttribute('data-fin'), handle = el.getAttribute('data-handle');
      swFetch(el.getAttribute('data-search'), model).then(function (items) {
        var list = items.filter(function (it) {
          var first = (it.t.split(' ')[0] || '').replace('®', '').toLowerCase();
          return first === model.toLowerCase() && swFin(it.t) === fin;
        });
        if (list.length < 2) return;
        list.sort(function (a, b) { return (a.h === handle ? -1 : b.h === handle ? 1 : 0) || (b.a - a.a); });
        var max = 6, html = '';
        list.slice(0, max).forEach(function (it) {
          var col = swColor(it.t, model, fin);
          var style = col ? ' style="background:' + col + '"' : (it.i ? ' style="background:#fff url(' + attr(it.i) + ') center/220% no-repeat"' : '');
          html += '<a class="pk-sw__dot' + (it.h === handle ? ' is-current' : '') + (it.a ? '' : ' is-out') + '" href="' + attr(it.u) + '" title="' + attr(it.t) + '" aria-label="' + attr(it.t) + '"' + style + '></a>';
        });
        if (list.length > max) html += '<span class="pk-sw__more">+' + (list.length - max) + '</span>';
        el.innerHTML = html;
        el.hidden = false;
      });
    });
  }
  /* Clic en un punto: siempre a la ficha de ese producto (por si el tema intercepta el clic) */
  document.addEventListener('click', function (e) {
    var d = e.target.closest && e.target.closest('.pk-sw__dot');
    if (!d || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = d.getAttribute('href');
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(); swInit(); });
  else { prepare(); swInit(); }
  document.addEventListener('shopify:section:load', function (e) { prepare(e.target); swInit(e.target); });
  /* Fichas cargadas por AJAX (filtros, "cargar más", recomendaciones) */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var added = list[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('[data-pk-qa]') || n.querySelector('[data-pk-qa]'))) { prepare(n.parentNode || n); }
          if (n.querySelector && (n.matches('[data-pk-sw]') || n.querySelector('[data-pk-sw]'))) { swInit(n.parentNode || n); }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Panel de tallas ---------- */
  var sheet = null, lastFocus = null, currentQa = null;

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'pk-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="pk-sheet__backdrop" data-pk-sheet-close></div>' +
      '<div class="pk-sheet__box" role="dialog" aria-modal="true" aria-labelledby="pk-sheet-name" tabindex="-1">' +
        '<div class="pk-sheet__head">' +
          '<img class="pk-sheet__img" alt="" width="64" height="64">' +
          '<div class="pk-sheet__info"><p class="pk-sheet__name" id="pk-sheet-name"></p><p class="pk-sheet__price"></p></div>' +
          '<button type="button" class="pk-sheet__close" data-pk-sheet-close aria-label="' + attr(t('close', 'Close')) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="pk-sheet__body">' +
          '<p class="pk-sheet__label">' + html(t('choose_size', 'Choose your size')) + ' <span>EU</span></p>' +
          '<ul class="pk-sheet__list"></ul>' +
          '<p class="pk-sheet__status" aria-live="polite"></p>' +
        '</div>' +
        '<div class="pk-sheet__foot"><a class="pk-sheet__link" href="#">' + html(t('view_product', 'View full details')) + '</a></div>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-pk-sheet-close]')) { closeSheet(); return; }
      var btn = e.target.closest('.pk-sheet__size');
      if (btn) handleAdd(btn, sheet.querySelector('.pk-sheet__status'), function () { setTimeout(closeSheet, 900); });
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = sheet.querySelectorAll('button:not([disabled]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function openSheet(qa) {
    if (!sheet) buildSheet();
    currentQa = qa;
    lastFocus = document.activeElement;
    var img = sheet.querySelector('.pk-sheet__img');
    var image = qa.getAttribute('data-image');
    if (image) { img.src = image; img.hidden = false; } else { img.hidden = true; }
    sheet.querySelector('.pk-sheet__name').textContent = qa.getAttribute('data-title') || '';
    var price = sheet.querySelector('.pk-sheet__price');
    price.textContent = (qa.getAttribute('data-price') || '').replace(/<[^>]*>/g, '');
    var compare = qa.getAttribute('data-compare');
    if (compare) { var s = document.createElement('s'); s.textContent = compare.replace(/<[^>]*>/g, ''); price.appendChild(s); }
    sheet.querySelector('.pk-sheet__link').href = qa.getAttribute('data-url') || '#';
    setStatus(sheet.querySelector('.pk-sheet__status'), '');

    var list = sheet.querySelector('.pk-sheet__list');
    list.innerHTML = '';
    (qa._panel || qa).querySelectorAll('.pk-qa__size').forEach(function (src) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pk-sheet__size';
      b.setAttribute('data-id', src.getAttribute('data-id'));
      if (src.disabled) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); }
      b.setAttribute('aria-label', src.getAttribute('aria-label') || src.textContent);
      var num = document.createElement('span');
      num.className = 'pk-sheet__num';
      num.textContent = src.textContent.trim();
      b.appendChild(num);
      var note = '';
      if (src.disabled) note = t('sold_out', 'Sold out');
      else if (src.hasAttribute('data-low')) note = t('low_stock', 'Last units');
      if (note) { var n = document.createElement('span'); n.className = 'pk-sheet__note'; n.textContent = note; b.appendChild(n); }
      li.appendChild(b);
      list.appendChild(li);
    });

    sheet.hidden = false;
    document.documentElement.classList.add('pk-sheet-lock');
    window.requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      var firstAvail = list.querySelector('.pk-sheet__size:not([disabled])');
      (firstAvail || sheet.querySelector('.pk-sheet__box')).focus({ preventScroll: true });
    });
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('pk-sheet-lock');
    setTimeout(function () { sheet.hidden = true; }, 320);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    currentQa = null;
  }

  /* ---------- Delegación de eventos (sirve para fichas cargadas por AJAX) ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-pk-qa-open]');
    if (open) {
      e.preventDefault();
      e.stopPropagation();
      openSheet(open.closest('[data-pk-qa]'));
      return;
    }
    var add = e.target.closest('[data-pk-qa-add]');
    if (add) {
      e.preventDefault();
      e.stopPropagation();
      var box = add.closest('.pk-qa__panel') || add.closest('[data-pk-qa]');
      var qa = add.closest('[data-pk-qa]') || (box && box._qa);
      var statusEl = (qa && qa._panel ? qa._panel : box).querySelector('.pk-qa__status');
      handleAdd(add, statusEl);
    }
  }, true);

  window.PKQuickAdd = { open: openSheet, close: closeSheet };
})();
